
import { motion } from 'framer-motion';

const testimonials = [
  {
    name: 'Ahmet Yılmaz',
    role: 'Bina Yöneticisi, Ataşehir Residence',
    text: 'Profesyonel ekip ve kaliteli hizmet. 200 daireli sitemize yangın algılama sistemi kurulumu sorunsuz tamamlandı. Teknik destek ekibi her zaman ulaşılabilir.',
    rating: 5,
    avatar: 'AY',
  },
  {
    name: 'Zeynep Kaya',
    role: 'İşletme Sahibi, Kaya Tekstil',
    text: 'Fabrikamız için en uygun çözümü sundular. Kurulum çok hızlı ve temiz yapıldı. 3 yıldır hiçbir sorun yaşamadık, düzenli bakımları da aksatmıyorlar.',
    rating: 5,
    avatar: 'ZK',
  },
  {
    name: 'Mehmet Demir',
    role: 'Genel Müdür, Demir Holding',
    text: 'Holding bünyesindeki 12 binamıza sistem kurdular. Merkezi izleme paneli sayesinde tüm binaları tek noktadan takip edebiliyoruz. Mükemmel hizmet.',
    rating: 5,
    avatar: 'MD',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-semibold text-red-600 tracking-wider uppercase">
            Müşteri Yorumları
          </span>
          <h4 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3 mb-4">
            <a href="#" className="cursor-default">
              Müşterilerimiz Ne Diyor?
            </a>
          </h4>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Hizmetlerimizden memnun kalan müşterilerimizin değerli görüşleri
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 relative"
            >
              <div className="absolute top-6 right-6 text-red-100">
                <i className="ri-double-quotes-r text-5xl"></i>
              </div>

              <div className="flex gap-1 mb-5">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-red-500 text-sm"></i>
                ))}
              </div>

              <p className="text-gray-700 text-sm leading-relaxed mb-6 relative z-10">
                &ldquo;{testimonial.text}&rdquo;
              </p>

              <div className="flex items-center gap-3 border-t border-gray-200 pt-5">
                <div className="w-10 h-10 flex items-center justify-center bg-red-600 text-white rounded-full text-sm font-bold flex-shrink-0">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{testimonial.name}</p>
                  <p className="text-gray-500 text-xs">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
